async function bootstrap() {
  if (import.meta.env.PROD) {
    const response = await fetch(`${import.meta.env.BASE_URL}config.json`, { cache: 'no-store' })
    if (!response.ok) {
      throw new Error(`Failed to load /config.json: ${response.status}`)
    }
    window.__APP_CONFIG__ = await response.json()
  }
  // Dynamic import: services/api/apiClient.js and others call config() at
  // module evaluation time, so they must load AFTER window.__APP_CONFIG__
  // has been populated. start() is called rather than run on import, so app.js
  // finishes evaluating before the router pulls in a view that imports from it.
  const { start } = await import('./app.js')
  await start()
}

bootstrap().catch((err) => {
  console.error('[bootstrap] Konfiguration konnte nicht geladen werden', err)
  document.body.textContent = 'Konfiguration konnte nicht geladen werden. Bitte Seite neu laden.'
})
